var React = require('react');

function ManageEngine (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Union","fillRule":"evenodd","clipRule":"evenodd","d":"M17.1432 2.25426C43.5015 -1.6266 54.3076 30.9305 42.775 45.9808C61.8591 26.7486 46.589 -7.21847 17.1432 2.25426ZM40.6867 2.48448C62.7913 17.855 53.5671 53.5234 29.9426 57.3804C60.2821 57.4043 70.1324 16.2682 40.6867 2.48448ZM1.5817 18.1411C14.5768 -1.10547 41.5755 10.8047 44.2807 30.2568C47.3825 6.21653 15.6904 -7.10837 1.5817 18.1411ZM0.946045 32.5315C4.10521 12.5537 30.105 10.4603 39.4726 24.4926C31.816 4.61038 1.45266 7.04308 0.946045 32.5315Z","fill":"#E0E7F6"}));
}

ManageEngine.defaultProps = {"width":"59","height":"58","viewBox":"0 0 59 58","fill":"none"};

module.exports = ManageEngine;

ManageEngine.default = ManageEngine;
